import { createSelector } from '@reduxjs/toolkit'

import { RootState } from '../../model/model'
import { Panel, PanelWithDoctorName } from '../../model/panel'
import { selectUsername } from '../auth/selectors'
import { selectUsers } from '../users/selectors'

export const selectPanels = (state: RootState): Panel[] => state.panels || []

export const selectPanelsWithDoctorsName = createSelector(selectPanels, selectUsers, (panels, users): PanelWithDoctorName[] =>
	panels?.map(panel => ({
		...panel,
		doctors: panel.doctors.map(doctor => {
			const doctorData = users.find(user => user.username === doctor.username)
			return {
				...doctor,
				name: doctorData?.name,
				surname: doctorData?.surname,
			}
		})
	}))
)

export const selectPanel = (panelId: string) => (
	state: RootState,
): Panel | undefined => {
	return state.panels?.find(({ _id }) => _id === panelId)
}

export const selectDoctorPanel = createSelector(selectUsername, selectPanels, (username, panels) =>
	panels?.filter(panel => panel.doctors.find(doctor => doctor.username === username)))

export const selectPanelsByDoctorUsername = (username: string) =>
	createSelector(selectPanels, panels =>
		panels?.filter(panel => panel.doctors.find(doctor => doctor.username === username)))

export const selectPanelStoresIds = createSelector(selectDoctorPanel, doctorPanels => doctorPanels.flatMap(({ stores }) => stores))

export const selectPanelsByStoreId = createSelector(selectPanels, panels => (storeId: string) =>
	panels?.filter(panel => panel.stores.find(store => store === storeId)))
